<div class="w-full mx-auto min-h-screen p-5 bg-gradient-to-br from-gray-50 to-blue-50 dark:from-gray-900 dark:to-blue-900/20">
  
  <!-- Header Section -->
  <div class="mb-8">
    <div class="rounded-2xl border border-stroke bg-gradient-to-br from-white to-blue-50 p-8 shadow-xl dark:border-strokedark dark:from-boxdark dark:to-blue-900/10">
      <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        
        <!-- Title Section -->
        <div class="flex items-center">
          <div class="mr-4 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-purple-400 to-purple-600 shadow-lg">
            <svg class="h-8 w-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
            </svg>
          </div>
          <div>
            <h1 class="text-3xl font-bold text-gray-900 dark:text-white">Solicitudes de Webhook Bitrix</h1>
            <p class="mt-1 text-gray-600 dark:text-gray-300">Gestión y seguimiento de solicitudes de inscripción desde Bitrix</p>
          </div>
        </div>

        <!-- Refresh Button -->
        <button (click)="loadData()" 
                class="group relative inline-flex items-center justify-center px-6 py-3 overflow-hidden font-medium text-white bg-gradient-to-br from-purple-500 to-purple-700 rounded-lg shadow-lg transition-all duration-300 ease-out hover:scale-105 hover:shadow-xl hover:from-purple-600 hover:to-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2">
          <svg class="relative mr-2 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
          </svg>
          <span class="relative">Actualizar</span>
          <div class="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transform -translate-x-full group-hover:translate-x-full transition-all duration-700"></div>
        </button>
      </div>

      <!-- Stats Section -->
      <div class="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" *ngIf="stats">
        <div class="rounded-lg bg-gradient-to-br from-blue-50 to-white p-4 border border-blue-100 dark:from-blue-900/10 dark:to-boxdark dark:border-blue-800/30">
          <div class="flex items-center">
            <div class="mr-3 flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100 dark:bg-blue-900/20">
              <svg class="h-5 w-5 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"/>
              </svg>
            </div>
            <div>
              <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Total Solicitudes</p>
              <p class="text-2xl font-bold text-gray-900 dark:text-white">{{ stats.totalRequests }}</p>
            </div>
          </div>
        </div>

        <div class="rounded-lg bg-gradient-to-br from-green-50 to-white p-4 border border-green-100 dark:from-green-900/10 dark:to-boxdark dark:border-green-800/30">
          <div class="flex items-center">
            <div class="mr-3 flex h-10 w-10 items-center justify-center rounded-lg bg-green-100 dark:bg-green-900/20">
              <svg class="h-5 w-5 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <div>
              <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Exitosas</p>
              <p class="text-2xl font-bold text-green-700 dark:text-green-400">{{ stats.successRequests }}</p>
              <p class="text-xs text-gray-500 dark:text-gray-400">{{ stats.successRate }}% éxito</p>
            </div>
          </div>
        </div>

        <div class="rounded-lg bg-gradient-to-br from-red-50 to-white p-4 border border-red-100 dark:from-red-900/10 dark:to-boxdark dark:border-red-800/30">
          <div class="flex items-center">
            <div class="mr-3 flex h-10 w-10 items-center justify-center rounded-lg bg-red-100 dark:bg-red-900/20">
              <svg class="h-5 w-5 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <div>
              <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Fallidas</p>
              <p class="text-2xl font-bold text-red-700 dark:text-red-400">{{ stats.failedRequests }}</p>
            </div>
          </div>
        </div>

        <div class="rounded-lg bg-gradient-to-br from-yellow-50 to-white p-4 border border-yellow-100 dark:from-yellow-900/10 dark:to-boxdark dark:border-yellow-800/30">
          <div class="flex items-center">
            <div class="mr-3 flex h-10 w-10 items-center justify-center rounded-lg bg-yellow-100 dark:bg-yellow-900/20">
              <svg class="h-5 w-5 text-yellow-600 dark:text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <div>
              <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Pendientes</p>
              <p class="text-2xl font-bold text-yellow-700 dark:text-yellow-400">{{ stats.pendingRequests }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="mb-6 rounded-xl border border-stroke bg-white p-6 shadow-default dark:border-strokedark dark:bg-boxdark">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="flex-1">
        <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">Buscar</label>
        <div class="relative">
          <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
            </svg>
          </div>
          <input type="text" 
                 [(ngModel)]="searchText"
                 (input)="onSearchChange()"
                 placeholder="Lead ID, Email, Nombre o Proyecto..."
                 class="w-full rounded-lg border border-gray-300 bg-white pl-10 pr-4 py-2.5 text-sm text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400">
        </div>
      </div>

      <div class="w-full md:w-48">
        <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">Estado</label>
        <select [(ngModel)]="statusFilter" 
                (change)="onStatusFilterChange()"
                class="w-full rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm text-gray-900 shadow-sm transition-all duration-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white">
          <option [value]="null">Todos los estados</option>
          <option [value]="BitrixRequestStatus.Pending">Pendiente</option>
          <option [value]="BitrixRequestStatus.Processing">Procesando</option>
          <option [value]="BitrixRequestStatus.Success">Exitoso</option>
          <option [value]="BitrixRequestStatus.Failed">Fallido</option>
        </select>
      </div>

      <div class="flex items-end">
        <button (click)="clearFilters()"
                class="px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600">
          <svg class="inline-block mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
          Limpiar
        </button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="grid grid-cols-1 gap-6 animate-fade-in">
    <div *ngFor="let i of [1,2,3]" class="animate-pulse">
      <div class="rounded-xl border border-stroke bg-white p-6 shadow-default dark:border-strokedark dark:bg-boxdark">
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center flex-1">
            <div class="h-12 w-12 bg-gray-200 rounded-lg dark:bg-gray-700"></div>
            <div class="ml-4 flex-1">
              <div class="h-4 bg-gray-200 rounded dark:bg-gray-700 mb-2 w-1/4"></div>
              <div class="h-3 bg-gray-200 rounded dark:bg-gray-700 w-1/3"></div>
            </div>
          </div>
          <div class="h-6 w-20 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && filteredRequests.length === 0" 
       class="text-center py-16 rounded-2xl border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
    <div class="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800">
      <svg class="h-10 w-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"/>
      </svg>
    </div>
    <h3 class="mt-6 text-xl font-semibold text-gray-900 dark:text-white">No se encontraron solicitudes</h3>
    <p class="mt-2 text-gray-500 dark:text-gray-400">
      {{ searchText || statusFilter !== null ? 'Intenta con otros filtros de búsqueda' : 'Las solicitudes de Bitrix aparecerán aquí' }}
    </p>
  </div>

  <!-- Requests List -->
  <div *ngIf="!loading && filteredRequests.length > 0" class="space-y-4 animate-fade-in">
    <div *ngFor="let request of filteredRequests" 
         (click)="viewDetail(request)"
         class="group relative rounded-xl border border-stroke bg-gradient-to-br from-white to-gray-50 p-6 shadow-default transition-all duration-300 hover:shadow-xl hover:scale-[1.01] cursor-pointer dark:border-strokedark dark:from-boxdark dark:to-gray-900/50">
      
      <!-- Header -->
      <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
        <div class="flex items-center flex-1">
          <div class="mr-4 flex h-12 w-12 items-center justify-center rounded-lg shadow-lg"
               [ngClass]="{
                 'bg-gradient-to-br from-yellow-400 to-yellow-600': request.status === BitrixRequestStatus.Pending,
                 'bg-gradient-to-br from-blue-400 to-blue-600': request.status === BitrixRequestStatus.Processing,
                 'bg-gradient-to-br from-green-400 to-green-600': request.status === BitrixRequestStatus.Success,
                 'bg-gradient-to-br from-red-400 to-red-600': request.status === BitrixRequestStatus.Failed
               }">
            <svg class="h-6 w-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="request.status === BitrixRequestStatus.Success ? 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z' : request.status === BitrixRequestStatus.Failed ? 'M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z' : 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'"/>
            </svg>
          </div>
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-2 mb-1">
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Lead ID: {{ request.leadId }}</h3>
              <!-- Badge de tipo (Entrada/Salida) -->
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                    [ngClass]="getRequestTypeBadgeClass(request.requestType)">
                <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="getRequestTypeIcon(request.requestType)"/>
                </svg>
                {{ getRequestTypeName(request.requestType) }}
              </span>
              <span *ngIf="request.retryCount > 0" 
                    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400">
                <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                </svg>
                {{ request.retryCount }} reintentos
              </span>
            </div>
            <p class="text-sm text-gray-500 dark:text-gray-400">
              {{ formatDate(request.requestDate) }}
              <span *ngIf="request.outboundAction" class="ml-2 text-purple-600 dark:text-purple-400">
                → {{ request.outboundAction }}
              </span>
            </p>
          </div>
        </div>
        
        <!-- Status Badge -->
        <span class="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium border-2"
              [ngClass]="{
                'bg-yellow-50 text-yellow-700 border-yellow-200 dark:bg-yellow-900/20 dark:text-yellow-400 dark:border-yellow-800': request.status === BitrixRequestStatus.Pending,
                'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-900/20 dark:text-blue-400 dark:border-blue-800': request.status === BitrixRequestStatus.Processing,
                'bg-green-50 text-green-700 border-green-200 dark:bg-green-900/20 dark:text-green-400 dark:border-green-800': request.status === BitrixRequestStatus.Success,
                'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/20 dark:text-red-400 dark:border-red-800': request.status === BitrixRequestStatus.Failed
              }">
          <svg class="w-2 h-2 mr-1.5" fill="currentColor" viewBox="0 0 8 8">
            <circle cx="4" cy="4" r="3"/>
          </svg>
          {{ getStatusName(request.status) }}
        </span>
      </div>

      <!-- Content -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div class="flex items-center text-sm text-gray-600 dark:text-gray-300">
          <svg class="mr-2 h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"/>
          </svg>
          <span class="font-medium mr-1">Proyecto:</span>
          <span *ngIf="request.projectMnemonic" class="px-2 py-0.5 bg-purple-100 text-purple-700 rounded text-xs font-medium dark:bg-purple-900/30 dark:text-purple-400">
            {{ request.projectMnemonic }}
          </span>
          <span *ngIf="!request.projectMnemonic" class="text-gray-400">-</span>
        </div>

        <div class="flex items-center text-sm text-gray-600 dark:text-gray-300">
          <svg class="mr-2 h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
          </svg>
          <span class="font-medium mr-1">Participante:</span>
          <span class="truncate">{{ request.participantName || request.participantEmail || '-' }}</span>
        </div>

        <div *ngIf="request.failureStep" class="flex items-center text-sm">
          <svg class="mr-2 h-4 w-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-1.964-1.333-2.732 0L3.732 16c-.77 1.333.192 3 1.732 3z"/>
          </svg>
          <span class="font-medium text-red-600 dark:text-red-400 mr-1">Error:</span>
          <span class="text-red-600 dark:text-red-400 text-xs font-medium">{{ request.failureStep }}</span>
        </div>
        
        <div *ngIf="request.processingTimeMs" class="flex items-center text-sm text-gray-600 dark:text-gray-300">
          <svg class="mr-2 h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          <span class="font-medium mr-1">Tiempo:</span>
          <span class="text-xs font-mono" 
                [ngClass]="{
                  'text-green-600 dark:text-green-400': request.processingTimeMs < 5000,
                  'text-yellow-600 dark:text-yellow-400': request.processingTimeMs >= 5000 && request.processingTimeMs < 15000,
                  'text-red-600 dark:text-red-400': request.processingTimeMs >= 15000
                }">
            {{ formatProcessingTime(request.processingTimeMs) }}
          </span>
        </div>
      </div>

      <!-- Error Message -->
      <div *ngIf="request.errorMessage" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg dark:bg-red-900/10 dark:border-red-800/30">
        <p class="text-sm text-red-700 dark:text-red-400">
          <svg class="inline-block w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          {{ request.errorMessage }}
        </p>
      </div>

      <!-- Actions -->
      <div class="flex justify-end gap-2 pt-4 border-t border-gray-200 dark:border-gray-700">
        <button (click)="viewDetail(request)"
                class="inline-flex items-center px-4 py-2 bg-purple-100 hover:bg-purple-200 text-purple-700 rounded-lg text-sm font-medium transition-all duration-200 hover:scale-105 dark:bg-purple-900/30 dark:hover:bg-purple-900/50 dark:text-purple-400">
          <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
          </svg>
          Ver Detalle
        </button>
        
        <button *ngIf="request.status === BitrixRequestStatus.Failed || request.status === BitrixRequestStatus.Pending"
                (click)="retryRequest(request, $event)"
                class="inline-flex items-center px-4 py-2 bg-green-100 hover:bg-green-200 text-green-700 rounded-lg text-sm font-medium transition-all duration-200 hover:scale-105 dark:bg-green-900/30 dark:hover:bg-green-900/50 dark:text-green-400">
          <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
          </svg>
          Reprocesar
        </button>
      </div>

      <!-- Hover Effect -->
      <div class="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transform -translate-x-full group-hover:translate-x-full transition-all duration-700 rounded-xl pointer-events-none"></div>
    </div>
  </div>

  <!-- Common Errors and Top Projects -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8" *ngIf="stats && (getCommonErrorsArray().length > 0 || getTopProjectsArray().length > 0)">
    <!-- Common Errors -->
    <div *ngIf="getCommonErrorsArray().length > 0" class="rounded-xl border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <div class="border-b border-stroke px-6 py-4 dark:border-strokedark">
        <h3 class="font-semibold text-gray-900 dark:text-white flex items-center">
          <svg class="mr-2 h-5 w-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-1.964-1.333-2.732 0L3.732 16c-.77 1.333.192 3 1.732 3z"/>
          </svg>
          Errores Más Comunes
        </h3>
      </div>
      <div class="p-6">
        <div class="space-y-3">
          <div *ngFor="let error of getCommonErrorsArray()" 
               class="flex items-center justify-between p-3 bg-red-50 rounded-lg border border-red-100 dark:bg-red-900/10 dark:border-red-800/30">
            <span class="text-sm font-medium text-gray-900 dark:text-white">{{ error.step }}</span>
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-600 text-white">
              {{ error.count }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Top Projects -->
    <div *ngIf="getTopProjectsArray().length > 0" class="rounded-xl border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <div class="border-b border-stroke px-6 py-4 dark:border-strokedark">
        <h3 class="font-semibold text-gray-900 dark:text-white flex items-center">
          <svg class="mr-2 h-5 w-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
          </svg>
          Proyectos Más Solicitados
        </h3>
      </div>
      <div class="p-6">
        <div class="space-y-3">
          <div *ngFor="let project of getTopProjectsArray()" 
               class="flex items-center justify-between p-3 bg-purple-50 rounded-lg border border-purple-100 dark:bg-purple-900/10 dark:border-purple-800/30">
            <span class="text-sm font-medium text-gray-900 dark:text-white">{{ project.project }}</span>
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-600 text-white">
              {{ project.count }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
